"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection3336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-3 col-lg-3 col-md-3 col-sm-6 d-flex" | "col-xl-3 col-lg-3 col-md-3 col-sm-6" */
    className: string;
    /** Detected variants: "Company" | "Our Services" */
    h50Text: ReactNode;
    /** Detected variants: "footer-widget" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h50ClassName?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Blogs" | "Fertility Consultation" | "IVF & ICSI Treatments" | "IUI Procedures" | "Egg Freezing" | "Genetic Testing" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.blogGrid" */
    href: string;
};
export type HomeTenFooterSectionGeneratedProps = {
    divDiv0H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection3336sItem) => Partial<ComponentProps<"h5">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "all_routes.home10" */
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "logo" */
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-10.svg" */
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Begin your parenthood journey with compassionate experts and advanced fertility care tailored just for you." */
    footerDiv0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "all_routes.booking" */
    footerDiv0Div0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "Book Consultaion" */
    footerDiv0Div0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    footerDiv0Div0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    footerDiv0Div0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv0Div1Div0P0PText?: ReactNode;
    /** Default: "icon" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/plus-bg.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-14.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection3336s: FooterSection3336sItem[];
    footerSection3336sItemWrapper?: (item: FooterSection3336sItem, content: ReactNode) => ReactNode;
    footerSection3336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection3336sH5Visible?: boolean;
    footerSection3336sH5Renderer?: (item: FooterSection3336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection3336sH5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection3336sItem) => Partial<ComponentProps<"h5">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeTenFooterSectionGenerated: FC<HomeTenFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-10.svg",
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkHref = "all_routes.home10",
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkVisible,
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkRenderer,
    footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkProps,
    footerDiv0Div0Div0Div0Div0Div0P0PText = "Begin your parenthood journey with compassionate experts and advanced fertility care tailored just for you.",
    footerDiv0Div0Div0Div0Div0Div1Link0LinkHref = "all_routes.booking",
    footerDiv0Div0Div0Div0Div0Div1Link0LinkText = "Book Consultaion",
    footerDiv0Div0Div0Div0Div0Div1Link0LinkVisible,
    footerDiv0Div0Div0Div0Div0Div1Link0LinkRenderer,
    footerDiv0Div0Div0Div0Div0Div1Link0LinkProps,
    footerDiv0Div1Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerImageWithBasePath0ImageAlt = "icon",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/plus-bg.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "icon",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-bg-14.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    divDiv0H50H5Props,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSection3336s,
    footerSection3336sItemWrapper,
    footerSection3336sRenderer,
    footerSection3336sH5Visible,
    footerSection3336sH5Renderer,
    footerSection3336sH5Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-ten">
            <div className="container">
                <div className="footer-top">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-xl-6 col-md-6 d-flex">
                            <div className="footer-widget footer-about flex-fill">
                                <div>
                                    <div className="footer-logo">
                                        {renderNode(footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkVisible, footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                            <SmartLink href={footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkHref} {...(footerDiv0Div0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                                {renderNode(footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageVisible, footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageRenderer, (
                                                    <SmartImage src={footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv0Div0Div0Div0Div0Div0Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <p>{footerDiv0Div0Div0Div0Div0Div0P0PText}</p>
                                </div>
                                <div>
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div1Link0LinkVisible, footerDiv0Div0Div0Div0Div0Div1Link0LinkRenderer, (
                                        <SmartLink href={footerDiv0Div0Div0Div0Div0Div1Link0LinkHref} className="btn btn-secondary" {...(footerDiv0Div0Div0Div0Div0Div1Link0LinkProps ?? {})}>
                                            <i className="isax isax-calendar-edit me-2" />
                                            {footerDiv0Div0Div0Div0Div0Div1Link0LinkText}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {renderCollectionNode(
                            footerSection3336s,
                            (item: FooterSection3336sItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName ?? "footer-widget"}>
                                        {renderItemNode(footerSection3336sH5Visible, footerSection3336sH5Renderer, item, (
                                            <h5 className={item.h50ClassName ?? "footer-title"} {...(typeof footerSection3336sH5Props === "function" ? footerSection3336sH5Props(item) : (footerSection3336sH5Props ?? {}))} {...(typeof divDiv0H50H5Props === "function" ? divDiv0H50H5Props(item) : (divDiv0H50H5Props ?? {}))}>{item.h50Text}</h5>
                                        ))}
                                        <ul className="footer-menu">
                                            {renderCollectionNode(
                                                item.footerMenuItems ?? [],
                                                (item: FooterSectionUlsItem) => (
                                                    <li key={item.key}>
                                                        {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </li>
                                                ),
                                                footerSectionUlsItemWrapper,
                                                footerSectionUlsRenderer
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            ),
                            footerSection3336sItemWrapper,
                            footerSection3336sRenderer
                        )}
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="copyright">
                        <p className="copyright-text">{footerDiv0Div1Div0P0PText}</p>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="footer-bg-01" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="footer-bg-02" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeTenFooterSectionGenerated;
